(function() {

    'use strict';

    angular.module('Services').service('CarrierFlatRateTableService', CarrierFlatRateTableService);

    CarrierFlatRateTableService.$inject = ['Carrier', 'TableLiteFactory'];

    function CarrierFlatRateTableService(Carrier, TableLiteFactory) {

        var tableData = {};

        var activeFilters = {};
        var paginationFilter = {};
        var sortingFilter = {
            page: 0
        };
        var tableStructure = {
            config: {
                noExtract: true
            },
            optionHeader: {
                title: "CENTRES PER KG'S",
                class: 'panel-title text-success p-t-3'
            },
            headers: [{
                label: 'COUNTRIES',
                viewName: 'country',
                filterName: 'country',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                },
            }, {
                label: 'ZONE NAME',
                viewName: 'zone_name',
                filterName: 'zone_name',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                },
            }, {
                label: 'ZONE FROM',
                viewName: 'zone_from',
                filterName: 'zone_from',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                },
            }, {
                label: 'ZONE TO',
                viewName: 'zone_to',
                filterName: 'zone_to',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                },
            }, {
                label: 'BASIC',
                viewName: 'basic',
                filterName: 'basic',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                },
            }, {
                label: 'MINIMUM',
                viewName: 'minimum',
                filterName: 'minimum',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                },
            }, {
                label: 'PER KG RATE',
                viewName: 'per_kg_rate',
                filterName: 'per_kg_rate',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                },
            }, {
                label: 'TRANSIT TIME',
                viewName: 'transit_time',
                filterName: 'transit_time',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                },
            }],
            data: [],
            applyFilters: function(item) {
                angular.extend(paginationFilter, {
                    size: item,
                    page: 0
                });
                sendRequest();
            },
            extractTable: function(form) {

            },
            onPageChanged: function() {
                angular.extend(paginationFilter, {
                    page: this.currentPage - 1
                });
                sendRequest();
            },
            rowOnClick: function(item) {},
            resetFilters: function() {

            },
            totalItems: 2,
            numberOfItems: 10,
            totalPages: 1,
            itemView: 20,
            itemViewRaw: 20,
            currentPage: 1
        };

        function sort(filterName) {
            if (tableData.sort && tableData.sort[0].property !== filterName) {
                sortingFilter.sort = filterName;
            } else if (!tableData.sort || tableData.sort[0].property == filterName &&
                !tableData.sort[0].direction.toLowerCase() == 'desc') {
                sortingFilter.sort = filterName;
            } else if (tableData.sort[0].direction.toLowerCase() == 'asc') {
                sortingFilter.sort = filterName + ',desc';
            } else if (tableData.sort[0].direction.toLowerCase() == 'desc') {
                delete sortingFilter.sort;
                delete paginationFilter.sort;
                delete activeFilters.sort;
            }

            sendRequest(sortingFilter);
        }

        function evaluateFilter(header) {
            var filter = {};
            if (header.filter.model)
                filter[header.filterName] = header.filter.model;
            else if (activeFilters[header.filterName])
                delete activeFilters[header.filterName];

            return filter;
        }

        function sendRequest(filter) {
            angular.extend(activeFilters, paginationFilter, filter);
            Carrier.getCarriers(function(data) {
                tableData = buildTableData(data);
            }, function(err) {}, activeFilters);
        };

        function buildTableData(data, pagination) {
            /*** START - Building of Data ***/
            if (pagination)
                paginationFilter = pagination;

            tableData = tableStructure;
            tableData.data = [];

            angular.extend(tableData, TableLiteFactory.getCommonProperties(data));

            angular.forEach(data.flat_rate, function(row, index) {
                
                //row.href = '/carriers/service-profile/view/' + row.id;

                tableData.data.push(row);
            });
            /*** END - Building of Data ***/

            return tableData;
        };
        return {
            buildTableData: buildTableData
        }
    };
})();



// WEBPACK FOOTER //
// ./js/services/tables/CarrierFlatRateTableService.js